/* @flow weak */
import ExternalAccountResourceActions from 'payments/actions/ExternalAccountResourceActions';
import Button from 'components/Button.jsx';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import Container from 'components/Container.jsx';
import EncryptionNotice from 'components/EncryptionNotice.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import FocusEventTrigger from 'components/FocusEventTrigger.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import React, { PropTypes } from 'react';
import SettingsStore from 'stores/SettingsStore';
import StripeAPI from 'lib/StripeAPI';
import ToastActions from 'actions/ToastActions';

import {
  STRIPE_ACCOUNT_TYPE_INDIVIDUAL,
  USD_CURRENCY,
  STRIPE_COUNTRY,
} from 'entities/PaymentAccount';
import {
  ROUTING_NUMBER,
  ACCOUNT_NUMBER,
  ChequeImageView,
} from 'payments/components/ChequeImageView.jsx';

import './styles/AddBankAccountForm.scss';

const AddBankAccountForm = React.createClass({
  propTypes: {
    hideChequeImage: PropTypes.bool,
    onBankAccountAdded: PropTypes.func,
    onAdminBankAccountAdd: PropTypes.func,
    connectedBankAccount: PropTypes.instanceOf(ConnectedBankAccount),
    accessToken: PropTypes.string,
  },

  contextTypes: {
    eventContextName: PropTypes.string,
    eventScreenName: PropTypes.string,
  },

  getDefaultProps() {
    return {
      hideChequeImage: false,
    };
  },

  getInitialState() {
    return {
      disabled: true,
      highlighted: null,
      loading: false,
    };
  },

  componentDidMount() {
    StripeAPI.setPublishableKey(SettingsStore.getStripeKey())
      .then(() => {}, this.handleScriptError);
  },

  handleFormSubmit(value) {
    this.setState({ loading: true });
    const onDone = () => {
      if (this.isMounted()) {
        this.setState({ loading: false });
      }
    };

    StripeAPI.createBankAccountToken({
      country: STRIPE_COUNTRY,
      currency: USD_CURRENCY,
      routing_number: value.routing_number,
      account_number: value.account_number,
      account_holder_type: STRIPE_ACCOUNT_TYPE_INDIVIDUAL,
    }, (status, response) => {
      if (response.error) {
        onDone();
        if (response.error.message) {
          ToastActions.showErrorToast(response.error.message);
        } else {
          ToastActions.showDefaultErrorToast();
        }
        return;
      }

      if (this.props.connectedBankAccount) {
        ConnectedBankAccountActions
          .approve(response.id, value.bank_account_name, null, this.props.connectedBankAccount.id)
          .then(this.props.onAdminBankAccountAdd, ToastActions.showDefaultErrorToast)
          .then(onDone, onDone);
      } else if (this.props.onAdminBankAccountAdd) {
        ConnectedBankAccountActions
          .approve(response.id, value.bank_account_name, this.props.accessToken)
          .then(this.props.onAdminBankAccountAdd, ToastActions.showDefaultErrorToast)
          .then(onDone, onDone);
      } else {
        ExternalAccountResourceActions
          .create(response.id)
          .then(this.props.onBankAccountAdded, ToastActions.showDefaultErrorToast)
          .then(onDone, onDone);
      }
    });
  },

  handleScriptError() {
    ToastActions.showDefaultErrorToast();
  },

  renderChequeImage() {
    if (!this.props.hideChequeImage) {
      return <ChequeImageView highlighted={this.state.highlighted} />;
    }
  },

  render() {
    const { eventContextName, eventScreenName } = this.context;

    return (
      <div className="AddBankAccountForm">
        <Container size="medium">
          <Form
            className="AddBankAccountForm-form"
            onValid={() => this.setState({ disabled: false })}
            onInvalid={() => this.setState({ disabled: true })}
            onValidSubmit={this.handleFormSubmit}>
            <div>
              <FocusEventTrigger
                eventScreenName={eventScreenName}
                eventContextName={eventContextName}
                eventElementName="routing_number"
                trackChildComponents>
                <FormInput
                  label="Routing number"
                  type="tel"
                  name="routing_number"
                  maxLength="9"
                  autofocus
                  autoComplete="off"
                  validations={{ isValidRoutingNumber: STRIPE_COUNTRY }}
                  validationErrors={{
                    isDefaultRequiredValue: 'Routing number is required',
                    isValidRoutingNumber: 'Routing number is invalid',
                  }}
                  onBlur={() => this.setState({ highlighted: null })}
                  onFocus={() => this.setState({ highlighted: ROUTING_NUMBER })}
                  showErrorAfterBlur
                  required
                />
              </FocusEventTrigger>
            </div>
            <div>
              <FocusEventTrigger
                eventScreenName={eventScreenName}
                eventContextName={eventContextName}
                eventElementName="account_number"
                trackChildComponents>
                <FormInput
                  label="Account number"
                  type="tel"
                  name="account_number"
                  autoComplete="off"
                  validations={{ isValidAccountNumber: STRIPE_COUNTRY }}
                  validationErrors={{
                    isDefaultRequiredValue: 'Account number is required',
                    isValidAccountNumber: 'Account number is invalid',
                  }}
                  onBlur={() => this.setState({ highlighted: null })}
                  onFocus={() => this.setState({ highlighted: ACCOUNT_NUMBER })}
                  showErrorAfterBlur
                  required
                />
              </FocusEventTrigger>
            </div>
            {this.renderChequeImage()}
            <Button
              loading={this.state.loading}
              className="AddBankAccountForm-submit"
              disabled={this.state.disabled}
              eventScreenName={EventTrackingConstants.CREATE_DEPOSIT_ACCOUNT}
              eventContextName={eventContextName}
              eventElementName="continue">
                Continue
            </Button>
          </Form>
          <EncryptionNotice />
        </Container>
      </div>
    );
  },
});

export default AddBankAccountForm;



// WEBPACK FOOTER //
// ./src/payments/components/AddBankAccountForm.jsx